module.exports = __webpack_public_path__ + "img/v4_userManual.1bd08378.png";